











































import _ from 'lodash';
import { editFactory } from '@/main/pages';
import { END_LOADING, ENTITY, START_LOADING } from '@/main/store/listEditTypes';
import { PageMode } from '@/main/utils/pageMode';
import dayjs from 'dayjs';
import { httpRequest } from '@/main/services/httpRequest';
import { getColumnsNames, Table } from '@/main/utils/table';
import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, validateDateFields, getCurrentLanguageId } from '@/main/utils/commonFunctions';
import { entityId, LOADED, MAX_DAYS, MIN_DAYS, NAME, OPEN_PART_SALE_ORDER, OPEN_SERVICE_ORDER, OUTSTANING_REVENUE_PART_SALE_ORDER, OUTSTANING_REVENUE_SERVICE_ORDER, TAB_NAMES, TABS } from './constants';
import { store } from './store/edit';
import { apiProvider } from './api';
import MultiSelect from '@/main/components/dms/form/MultiSelect.vue';

export default editFactory(NAME, store).extend({
	provide() {
		return { pageMode: this.pageMode };
	},
	data() {
		return {
			tabNames: TAB_NAMES,
			outstandingUrl: 'null' as string,
			fromDate: 'DateFrom',
			toDate: 'DateTo',
		};
	},
	computed: {
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(NAME, TABS.OPEN_SERVICE_ORDER)) tabItems.push(TAB_NAMES.OpenServiceOrder);
			if (this.hasTabAccess(NAME, TABS.OPEN_PART_SALE_ORDER)) tabItems.push(TAB_NAMES.OpenPartSaleOrder);

			return _.pick(TABS, tabItems);
		},
		pageMode(): PageMode {
			return PageMode.EDIT;
		},
		tableListeners(): {} {
			return {
				'save-column-setting': this.saveColumnSetting,
			};
		},
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.WorkshopId);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.WorkshopId);
		},
	},
	methods: {
		async baseCreated() {
			this.entityId = entityId;
			await this.storeToPageManager();
		},
		entity() {
			return this.$store.dispatch(`${this.storeUri}/${ENTITY}`, { id: this.entityId });
		},
		async loadedData() {
			const startTime = performance.now();
			await this.loadSchemas();
			await this.loadDataForGrid();
			let iTotalTimeTaken = performance.now() - startTime;
            let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await apiProvider.logPerformance('ReportsPrp', `WIP Ouststanding Revenue ${OPEN_SERVICE_ORDER} Report`, LOADED, seconds);
		},
		async tabClicked(tab: any) {
			const startTime = performance.now();
			if (this.WorkshopId == null || this.WorkshopId.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
			 if(!this.isMultipleWorkshopSelected)
			await this.loadDataForGrid(tab.$props.name);
		    let reportType = tab.$props.name === this.tabNames.OpenServiceOrder ? OPEN_SERVICE_ORDER : OPEN_PART_SALE_ORDER;
		    let iTotalTimeTaken = performance.now() - startTime;
            let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await apiProvider.logPerformance('ReportsPrp', `WIP Ouststanding Revenue ${reportType} Report`, LOADED, seconds);
		},
		async loadSchemas() {
			try {
				this.startLoading();
				await this.fetchTableSchemas([OUTSTANING_REVENUE_SERVICE_ORDER, OUTSTANING_REVENUE_PART_SALE_ORDER]);
			} catch (error) {
				this.endLoading();
			} finally {
				this.endLoading();
			}
		},
		async searchData() {
			const startTime = performance.now();
			if (!validateDateFields(this, this.fromDate, this.toDate)) {
				return;
			}
			if (this.WorkshopId == null || this.WorkshopId.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
			if (isMultipleWorkshopSelected(this.WorkshopId)) {
				const defaultTab = this.tabNames.OpenServiceOrder;
				const active = this.activeTabName || defaultTab;
				const isService = active === this.tabNames.OpenServiceOrder;
				const table = isService
					? this.dependentTables.OutstandingRevenueOpenServiceOrder
					: this.dependentTables.OutstandingRevenueOpenPartSaleOrder;
				const getColSeqForServiceOrder = getColumnsNames(this.dependentTables.OutstandingRevenueOpenServiceOrder.columns.filter(x => x.isVisible === true));
				const getColSeqForPartsSales = getColumnsNames(this.dependentTables.OutstandingRevenueOpenPartSaleOrder.columns.filter(x => x.isVisible === true));
				await handleMultiWorkshopFilter(
					{ ...this, table },
					NAME,
					this.WorkshopId,
					() => ({
						WorkshopId: this.WorkshopId,
						DateFrom: this.DateFrom,
						DateTo: this.DateTo,
						ColumnSequenceServiceOrder: getColSeqForServiceOrder.join(','),
						ColumnSequencePartsSale: getColSeqForPartsSales.join(','),
						LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
					}),
				);
				if (this.dependentTables?.OutstandingRevenueOpenServiceOrder) {
					this.dependentTables.OutstandingRevenueOpenServiceOrder.rows = [];
				}
				if (this.dependentTables?.OutstandingRevenueOpenPartSaleOrder) {
					this.dependentTables.OutstandingRevenueOpenPartSaleOrder.rows = [];
				}
			} else {
				await this.loadDataForGrid();
			}
			let reportType = this.activeTabName === this.tabNames.OpenServiceOrder ? OPEN_SERVICE_ORDER : OPEN_PART_SALE_ORDER;
			let iTotalTimeTaken = performance.now() - startTime;
            let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
			await apiProvider.logPerformance('ReportsPrp', `WIP Ouststanding Revenue ${reportType} Report`, LOADED, seconds);
		},
		async loadDataForGrid(tabName: string = '') {
			if (this.isValidDateRange()) {
				try {
					this.startLoading();
					if ((tabName && tabName === TABS.OPEN_SERVICE_ORDER.id) || (!tabName && (this.activeTabName === null || this.activeTabName === TABS.OPEN_SERVICE_ORDER.id))) {
						await this.fetchTableData([OUTSTANING_REVENUE_SERVICE_ORDER]);
					} else {
						await this.fetchTableData([OUTSTANING_REVENUE_PART_SALE_ORDER]);
					}
				} catch (error) {
					this.endLoading();
				} finally {
					this.endLoading();
				}
			}
		},
		validation(workshopId: any, DateFrom: any, DateTo: any) {
			this.outstandingUrl = `dateFrom=${DateFrom}&dateTo=${DateTo}`;

			if (workshopId.length > 0) {
				workshopId.forEach((o: any) => {
					this.outstandingUrl = this.outstandingUrl.concat(`&workshopId=${o}`);
				});
			} else {
				this.outstandingUrl = workshopId;
			}
			return this.outstandingUrl;
		},
		async exportData() {
			if (this.isValidDateRange()) {
				try {
					if (this.WorkshopId == null || this.WorkshopId.length === 0) {
						this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
						return;
					}
					const getColSeqForServiceOrder = getColumnsNames(this.dependentTables.OutstandingRevenueOpenServiceOrder.columns.filter(x => x.isVisible === true));
					const getColSeqForPartsSales = getColumnsNames(this.dependentTables.OutstandingRevenueOpenPartSaleOrder.columns.filter(x => x.isVisible === true));
					this.startLoading();
					const params = this.validation(this.WorkshopId, new Date(this.DateFrom!).toISOString(), new Date(this.DateTo!).toISOString());
					if (this.isMultipleWorkshopSelected) {
						this.showErrorAlert({
							message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
						});
					} else {
						await apiProvider.GetOutstandingRevenueReportExcel(params, getColSeqForServiceOrder, getColSeqForPartsSales, getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId));
					}
				} catch (error) {
					this.endLoading();
				} finally {
					this.endLoading();
				}
			}
		},
		async validateDates() {
			this.isValidDateRange();
		},
		isValidDateRange(): boolean {
			if (this.DateFrom && this.DateTo) {
				const daysDifferance = dayjs(new Date(this.DateTo)?.toDateString()).diff(dayjs(new Date(this.DateFrom)?.toDateString()), 'days');
				if (daysDifferance < MIN_DAYS) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('GREATER_DATE_VALIDATION') });
					return false;
				} if (daysDifferance > MAX_DAYS) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('CR_MAX_DAYS_VALIDATION').replace('<DAYS>', `${MAX_DAYS}`) });
					return false;
				}
				return true;
			}
			this.showErrorAlert({ message: this.LocalizePopisPoli('CR_DATE_VALIDATION') });
			return false;
		},
		async saveColumnSetting(columns: string) {
			let gridId = this.dependentTables[OUTSTANING_REVENUE_SERVICE_ORDER]?.gridId;
			if (this.activeTabName === this.tabNames.OpenServiceOrder) {
				gridId = this.dependentTables[OUTSTANING_REVENUE_SERVICE_ORDER]?.gridId;
			} else if (this.activeTabName === this.tabNames.OpenPartSaleOrder) {
				gridId = this.dependentTables[OUTSTANING_REVENUE_PART_SALE_ORDER]?.gridId;
			}
			this.$store.commit(`${this.storeUri}/${START_LOADING}`);
			await httpRequest.post(`Grid?gridId=${gridId}`, { userColumnsSettings: columns });
			if ((this.activeTabName === this.tabNames.OpenServiceOrder || this.activeTabName === null) && this.hasTabAccess(NAME, TABS.OPEN_SERVICE_ORDER)) {
				this.fetchTableSchemas([OUTSTANING_REVENUE_SERVICE_ORDER]);
			} else {
				this.fetchTableSchemas([OUTSTANING_REVENUE_PART_SALE_ORDER]);
			}
			this.$store.commit(`${this.storeUri}/${END_LOADING}`);
		},
	},
});
